import { SVGProps } from 'react';

const IcCheckService = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='27'
      height='28'
      viewBox='0 0 27 28'
      fill='none'
      {...props}
    >
      <path
        d='M10.9741 20.6667C10.6183 20.6667 10.2804 20.5179 10.0314 20.2575L4.9977 14.9929C4.48189 14.4535 4.48189 13.5606 4.9977 13.0211C5.51351 12.4816 6.36727 12.4816 6.88308 13.0211L10.9741 17.2997L20.1164 7.73798C20.6322 7.19851 21.4859 7.19851 22.0018 7.73798C22.5176 8.27745 22.5176 9.17037 22.0018 9.70984L11.9168 20.2575C11.6678 20.5179 11.3298 20.6667 10.9741 20.6667Z'
        fill='white'
      />
    </svg>
  );
};

export default IcCheckService;
